<template>
<div>
  <b-container>
    <b-row>
      <b-col md="6">
        <h1>Add Company</h1>
        
        <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
        
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-form-group
              label="Name"
            >
              <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                <b-form-input v-model="form.name" :state="errors[0] ? false : null"></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>

            <b-form-group
              label="Org No."
            >
              <b-form-input v-model="form.orgNo"></b-form-input>
            </b-form-group>

            <b-form-group
              label="Address"
            >
              <b-form-input v-model="form.address"></b-form-input>
            </b-form-group>

            <b-form-row>
              <b-col cols="3">
                <b-form-group
                  label="Post code"
                >
                  <b-form-input v-model="form.postCode"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="City">
                  <b-form-input v-model="form.city"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            
            <b-form-checkbox
              class=mb-3
              v-model="form.isInternal"
            >
              Internal
            </b-form-checkbox>

            <b-card class="my-3" no-body header-bg-variant="primary" header-text-variant="white">
              <template v-slot:header>
                <span class="align-middle">Files</span>
                <div class="float-right">
                  <b-btn class="btn-circle" variant="light" @click="showFileDialog = true"><b-icon-plus></b-icon-plus></b-btn>
                </div>
              </template>
              <b-list-group flush>
                <b-list-group-item v-for="f in files" :key="f.id">
                  {{ f.name }}
                  <div class="float-right">
                    <b-button size="sm" variant="outline-secondary" class="mr-2" @click="display(f)">
                      <b-icon-card-text></b-icon-card-text>
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" @click="deleteFile(f)"><b-icon-trash></b-icon-trash></b-button>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </b-card>

            <b-button variant="outline-secondary" class="mr-2" to="/company">Back</b-button>
            <b-button type="submit" variant="primary">Save</b-button>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>

    <AddCompanyFileModal 
      v-model="showFileDialog"
      :doc-types="docTypes"
      @file="uploadFile"
    />
  </b-container>
</div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import AddCompanyFileModal from '../components/AddCompanyFileModal';
import axios from 'axios';

export default {
    components: { ValidationProvider, ValidationObserver, AddCompanyFileModal },
    data() {
      return {
        form: {
          id: 0,
          name: '',
          orgNo: '',
          address: '',
          postCode: '',
          city: '',
          isInternal: false
        },
        files: [],
        error: '',
        showFileDialog: false,
        docTypes: null
      }
    },
    methods: {
      save() {
        this.error = '';

        const companyDocs = this.files.map(f => {
          return {
            companyId: 0,
            companyDocTypeId: f.docTypeId,
            docTypeName: f.name,
            fileId: f.id
           }
        })

        axios.post('/api/companies', { ...this.form, companyDocs })
        .then(() => {
          this.$router.push('/company');
        })
        .catch(() => { 
          this.error = 'Failed to save';
        });
      },
      uploadFile(form) {
        const fd = new FormData();

        fd.append('file', form.file);

        axios.post('/api/file', fd)
        .then(res => {
          this.files.push({ 
            id: res.data,
            name: form.docTypeName,
            docTypeId: form.companyDocTypeId,
            file: form.file 
          });
        });
      },
      display(file) {
        let link = document.createElement('a');
        link.href = URL.createObjectURL(file.file);
        link.download = file.name;
        link.click();

        URL.revokeObjectURL(link.href);
      },
      deleteFile(file) {
        axios.delete(`/api/file/${file.id}`)
        .finally(() => {
          const index = this.files.findIndex(f => f.id === file.id);

          if (index > -1) {
            this.files.splice(index, 1);
          }
        });
      }
    },
    created() {
      axios.get('/api/companydoctypes').then(res => this.docTypes = res.data);
    }
}
</script>